import React from "react";
const MemberList = React.memo(({ children }) => {
    return (React.createElement("div", { style: { flex: 1, overflow: "auto" } }, children));
});
export default MemberList;
